import { ActivityService } from '@/api/AuthService'
const accessTypes = {
  READ: 1,
  WRITE: 2,
}

const infoTypes = {
  USERS: 100,
  ENTITIES: 110,
  PEOPLE: 130,
}

const serviceIdentifier = 'configurations'

const state = {
  accessTypes,
  infoTypes,
  entities: [],
  serviceIdentifier,
  clusters: [],
  availableActivities: []
}

const getters = {
  authenticationService: (state, rootState) => {
    return rootState.services.find(service => service.service === state.serviceIdentifier)
  },
  authenticationAccessTypes: state => state.accessTypes,
  authenticationInfoTypes: state => state.infoTypes,
  clusters2: state => state.clusters,
}

const actions = {
  loadAvailableActivities ({ commit }) {
    ActivityService.query()
      .then(activities => {
        commit('setActivities', activities)
      }).catch(err => {
        console.log(err)
      })
  },
  loadClusters ({ commit }, url) {
    this._vm.$http({
      url: url,
    }).then((response) => {
      commit('setClusters', response.data.data)
    }).catch((error) => {
      console.log(error)
    })
  },
}

const mutations = {
  setEntities (state, data) {
    state.entities = data
  },
  setClusters (state, data) {
    state.clusters = data
  },
  setActivities (state, data) {
    state.availableActivities = data
  }
}

export default {
  state,
  mutations,
  getters,
  actions,
}
